/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gYEVvAzCcLMHDVPvuYxkFh
// Component: gkx-PRZnjFPo

import * as React from "react";

import {
  Flex as Flex__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useDollarState,
  useTrigger,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import IconButton from "../../components/widgets/IconButton"; // plasmic-import: LPry-TF4j22a/component
import MenuButton from "../../components/widgets/MenuButton"; // plasmic-import: h69wHrrKtL/component

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_plasmic_kit_design_system_deprecated_css from "../PP__plasmickit_design_system.module.css"; // plasmic-import: tXkSR39sgCDWSitZxC5xFV/projectcss
import plasmic_plasmic_kit_color_tokens_css from "../plasmic_kit_q_4_color_tokens/plasmic_plasmic_kit_q_4_color_tokens.module.css"; // plasmic-import: 95xp9cYcv7HrNWpFWWhbcv/projectcss
import projectcss from "../plasmic_kit_style_controls/plasmic_plasmic_kit_styles_pane.module.css"; // plasmic-import: gYEVvAzCcLMHDVPvuYxkFh/projectcss
import sty from "./PlasmicRowItem.module.css"; // plasmic-import: gkx-PRZnjFPo/css

import ComponentsSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ComponentsSvg"; // plasmic-import: coPzxnFyi/icon

createPlasmicElementProxy;

export type PlasmicRowItem__VariantMembers = {
  showAddendum: "showAddendum";
  hideIcon: "hideIcon";
  menuSize: "small";
  isSelected: "isSelected";
  showActions: "showActions";
};
export type PlasmicRowItem__VariantsArgs = {
  showAddendum?: SingleBooleanChoiceArg<"showAddendum">;
  hideIcon?: SingleBooleanChoiceArg<"hideIcon">;
  menuSize?: SingleChoiceArg<"small">;
  isSelected?: SingleBooleanChoiceArg<"isSelected">;
  showActions?: SingleBooleanChoiceArg<"showActions">;
};
type VariantPropType = keyof PlasmicRowItem__VariantsArgs;
export const PlasmicRowItem__VariantProps = new Array<VariantPropType>(
  "showAddendum",
  "hideIcon",
  "menuSize",
  "isSelected",
  "showActions"
);

export type PlasmicRowItem__ArgsType = {
  icon?: React.ReactNode;
  children?: React.ReactNode;
  addendum?: React.ReactNode;
  actions?: React.ReactNode;
};
type ArgPropType = keyof PlasmicRowItem__ArgsType;
export const PlasmicRowItem__ArgProps = new Array<ArgPropType>(
  "icon",
  "children",
  "addendum",
  "actions"
);

export type PlasmicRowItem__OverridesType = {
  root?: Flex__<"div">;
  iconContainer?: Flex__<"div">;
  labelContainer?: Flex__<"div">;
  addendumContainer?: Flex__<"div">;
  freeBox?: Flex__<"div">;
  actionsContainer?: Flex__<"div">;
  menuButton?: Flex__<typeof MenuButton>;
};

export interface DefaultRowItemProps {
  icon?: React.ReactNode;
  children?: React.ReactNode;
  addendum?: React.ReactNode;
  actions?: React.ReactNode;
  showAddendum?: SingleBooleanChoiceArg<"showAddendum">;
  hideIcon?: SingleBooleanChoiceArg<"hideIcon">;
  menuSize?: SingleChoiceArg<"small">;
  isSelected?: SingleBooleanChoiceArg<"isSelected">;
  showActions?: SingleBooleanChoiceArg<"showActions">;
  className?: string;
}

const $$ = {};

function PlasmicRowItem__RenderFunc(props: {
  variants: PlasmicRowItem__VariantsArgs;
  args: PlasmicRowItem__ArgsType;
  overrides: PlasmicRowItem__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "showAddendum",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.showAddendum,
      },
      {
        path: "hideIcon",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.hideIcon,
      },
      {
        path: "menuSize",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.menuSize,
      },
      {
        path: "isSelected",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.isSelected,
      },
      {
        path: "showActions",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.showActions,
      },
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs,
  });

  const [isRootHover, triggerRootHoverProps] = useTrigger("useHover", {});
  const triggers = {
    hover_root: isRootHover,
  };

  return (
    <Stack__
      as={"div"}
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_plasmic_kit_design_system_deprecated_css.plasmic_tokens,
        plasmic_plasmic_kit_color_tokens_css.plasmic_tokens,
        sty.root,
        {
          [sty.rootisSelected]: hasVariant($state, "isSelected", "isSelected"),
          [sty.rootshowActions]: hasVariant(
            $state,
            "showActions",
            "showActions"
          ),
        }
      )}
      data-plasmic-trigger-props={[triggerRootHoverProps]}
    >
      {(hasVariant($state, "hideIcon", "hideIcon") ? false : true) ? (
        <div
          data-plasmic-name={"iconContainer"}
          data-plasmic-override={overrides.iconContainer}
          className={classNames(projectcss.all, sty.iconContainer, {
            [sty.iconContainerhideIcon]: hasVariant(
              $state,
              "hideIcon",
              "hideIcon"
            ),
          })}
        >
          {renderPlasmicSlot({
            defaultContents: (
              <ComponentsSvgIcon
                className={classNames(projectcss.all, sty.svg___5Mr7N)}
                role={"img"}
              />
            ),

            value: args.icon,
            className: classNames(sty.slotTargetIcon, {
              [sty.slotTargetIconisSelected]: hasVariant(
                $state,
                "isSelected",
                "isSelected"
              ),
            }),
          })}
        </div>
      ) : null}
      <div
        data-plasmic-name={"labelContainer"}
        data-plasmic-override={overrides.labelContainer}
        className={classNames(projectcss.all, sty.labelContainer, {
          [sty.labelContainermenuSize_small]: hasVariant(
            $state,
            "menuSize",
            "small"
          ),
          [sty.labelContainershowAddendum]: hasVariant(
            $state,
            "showAddendum",
            "showAddendum"
          ),
        })}
      >
        {renderPlasmicSlot({
          defaultContents: "Some very long item label",
          value: args.children,
          className: classNames(sty.slotTargetChildren),
        })}
      </div>
      <div
        data-plasmic-name={"addendumContainer"}
        data-plasmic-override={overrides.addendumContainer}
        className={classNames(projectcss.all, sty.addendumContainer, {
          [sty.addendumContainershowAddendum]: hasVariant(
            $state,
            "showAddendum",
            "showAddendum"
          ),
        })}
      >
        {renderPlasmicSlot({
          defaultContents: (
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__kNu3S
              )}
            >
              {"Big  Addendum"}
            </div>
          ),
          value: args.addendum,
          className: classNames(sty.slotTargetAddendum, {
            [sty.slotTargetAddendumshowAddendum]: hasVariant(
              $state,
              "showAddendum",
              "showAddendum"
            ),
          }),
        })}
      </div>
      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames(projectcss.all, sty.freeBox)}
      >
        {(hasVariant($state, "showActions", "showActions") ? true : false) ? (
          <div
            data-plasmic-name={"actionsContainer"}
            data-plasmic-override={overrides.actionsContainer}
            className={classNames(projectcss.all, sty.actionsContainer, {
              [sty.actionsContainershowActions]: hasVariant(
                $state,
                "showActions",
                "showActions"
              ),
            })}
          >
            {renderPlasmicSlot({
              defaultContents: (
                <IconButton
                  className={classNames(
                    "__wab_instance",
                    sty.iconButton__o5Pq2
                  )}
                  size={"small"}
                />
              ),

              value: args.actions,
            })}
          </div>
        ) : null}
        <MenuButton
          data-plasmic-name={"menuButton"}
          data-plasmic-override={overrides.menuButton}
          className={classNames("__wab_instance", sty.menuButton, {
            [sty.menuButtonmenuSize_small]: hasVariant(
              $state,
              "menuSize",
              "small"
            ),
          })}
          size={hasVariant($state, "menuSize", "small") ? "small" : undefined}
          withBackgroundHover={true}
        />
      </div>
    </Stack__>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "iconContainer",
    "labelContainer",
    "addendumContainer",
    "freeBox",
    "actionsContainer",
    "menuButton",
  ],
  iconContainer: ["iconContainer"],
  labelContainer: ["labelContainer"],
  addendumContainer: ["addendumContainer"],
  freeBox: ["freeBox", "actionsContainer", "menuButton"],
  actionsContainer: ["actionsContainer"],
  menuButton: ["menuButton"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  iconContainer: "div";
  labelContainer: "div";
  addendumContainer: "div";
  freeBox: "div";
  actionsContainer: "div";
  menuButton: typeof MenuButton;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicRowItem__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicRowItem__VariantsArgs;
    args?: PlasmicRowItem__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicRowItem__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicRowItem__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicRowItem__ArgProps,
          internalVariantPropNames: PlasmicRowItem__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicRowItem__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicRowItem";
  } else {
    func.displayName = `PlasmicRowItem.${nodeName}`;
  }
  return func;
}

export const PlasmicRowItem = Object.assign(
  // Top-level PlasmicRowItem renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    iconContainer: makeNodeComponent("iconContainer"),
    labelContainer: makeNodeComponent("labelContainer"),
    addendumContainer: makeNodeComponent("addendumContainer"),
    freeBox: makeNodeComponent("freeBox"),
    actionsContainer: makeNodeComponent("actionsContainer"),
    menuButton: makeNodeComponent("menuButton"),

    // Metadata about props expected for PlasmicRowItem
    internalVariantProps: PlasmicRowItem__VariantProps,
    internalArgProps: PlasmicRowItem__ArgProps,
  }
);

export default PlasmicRowItem;
/* prettier-ignore-end */
